import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Barrio } from 'app/entities/Barrio';
import { Observable } from 'rxjs';
import { ServiciosService } from '../../services/servicios.service';
import { DireccionService } from '../../services/direccion.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Municipio } from '../../entities/municipios';
import { Comuna } from '../../entities/comunas';
import { DireccionServicioComponent } from '../direccion-servicio/direccion-servicio.component';
import swal from 'sweetalert2';

@Component({
  selector: 'app-barrio',
  templateUrl: './barrio.component.html',
  styleUrls: ['./barrio.component.scss']
})
export class BarrioComponent implements OnInit{
    public formulario: FormGroup;
    public cities$: Observable<Array<Municipio>>;
    public comunas$: Observable<Array<Comuna>>;
    constructor(private _fb: FormBuilder, public _geo: DireccionService, @Inject(MAT_DIALOG_DATA) private _data, private _mat: MatDialog) {
        this.formulario = this._fb.group({
            nombre: [''],
            ciudad: [''],
            comuna: [''],
            lat: [],
            lng: []
        });
        this.cities$ = this._geo.getCiudades();
        if (this._data.city){
            this.formulario.get("ciudad").setValue(this._data.city);
            this.comunas$ = this._geo.getComunasDeUnaCiudad(this._data.city);
        }
    }

    ngOnInit() {
    }

    loadComunas(){
        console.log(this.formulario.get("ciudad").value);
        this.comunas$ = this._geo.getComunasDeUnaCiudad(this.formulario.get("ciudad").value);
    }
    coordenadas(){
        const coords: MatDialogRef<DireccionServicioComponent> = this._mat.open(DireccionServicioComponent,{
            width:'70%',
            height:'90%'
        });
        coords.afterClosed().subscribe((coords:{lat:number, lng:number}) => {
            this.formulario.get("lat").setValue(coords.lat);
            this.formulario.get("lng").setValue(coords.lng);
        })
    }

    save(){
        this._geo.newBarrio(this.formulario.value)
            .subscribe(log=>swal.fire({
                title:'Exito',
                type:'success',
                text:'Se guardó con exito el barrio',
                showConfirmButton: false,
                timer:1000
            }));

    }

}
